export default __webpack_public_path__ + "src/docs/packages/hillsneck-safari-lodge.pdf";